import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('IDX_isDefault', ['isDefault'], {})
@Index('UK_processorType', ['processorType'], { unique: true })
@Entity('payment_processor_config')
export class PaymentProcessorConfigEntity extends BaseEntity {
	@Column('enum', {
		name: 'processorType',
		unique: true,
		enum: ['authorize_net', 'epaymints', 'cybersource', 'nmi', 'adyen'],
	})
	public processorType!:
		| 'authorize_net'
		| 'epaymints'
		| 'cybersource'
		| 'nmi'
		| 'adyen';

	@Column('tinyint', { name: 'isDefault', default: () => "'0'" })
	public isDefault!: number;

	@Column('json', { name: 'credentials' })
	public credentials!: object;

	@Column('enum', {
		name: 'environment',
		enum: ['sandbox', 'production'],
		default: () => "'sandbox'",
	})
	public environment!: 'sandbox' | 'production';
}
